<template>
<div class="content">
	<div class="header">
		<nav class="navbar navbar-expand-lg navbar-light">
			<a href="/" class="navbar-brand">
				<img class="logo_a" src="/images/logo-bpb.png" alt="Logo Bien para Bien" title="Bien para Bien" />
			</a>

			<button
				class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#navMain"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<span class="navbar-toggler-icon"></span>
			</button>

			<div id="navMain" class="collapse navbar-collapse">
				<ul class="navbar-nav">
					<li class="nav-item">
						<a href="" class="nav-link nav-active" v-scroll-to="'#credito'">INICIAR SOLICITUD</a>
					</li>
					<li class="nav-item">
						<a href="" class="nav-link" v-scroll-to="'#benefits'">BENEFICIOS</a>
					</li>
					<li class="nav-item">
						<a href="" class="nav-link" v-scroll-to="'#requisitos'">NOSOTROS</a>
					</li>
					<li class="nav-item">
						<a href="" class="nav-link" v-scroll-to="'#plazas'">COBERTURA</a>
					</li>
				</ul>
			</div>
		</nav>
	</div>
	<div class="main">
		<div class="component">
			<Hooper
				:autoPlay="true"
				:playSpeed="5000"
				:wheelControl="false"
				:mouseDrag="false"
				:touchDrag="false"
				:keysControl="false"
				:hoverPause="false"
			>
				<slide><img src="/images/thumb1.png" alt="Bien para Bien. Créditos que hacen bien." /></slide>
				<slide><img src="/images/thumb2.png" alt="Bien para Bien. Créditos que hacen bien." /></slide>
				<slide><img src="/images/thumb3.png" alt="Bien para Bien. Créditos que hacen bien." /></slide>
				<slide><img src="/images/thumb4.png" alt="Bien para Bien. Créditos que hacen bien." /></slide>
			</Hooper>
			<div id="credito" class="credito-info">
				<div class="row">
					<div class="col-md-12 subtitle">
						Solicitar un crédito para liquidar deudas, no tiene por qué ser difícil. <br />¡Estamos aquí para
						ayudarte!
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<p class="white blue-on-mobile">
							Tu casa u oficina puede darte un crédito accesible, confiable y libre de comisiones.
						</p>
					</div>
				</div>
			</div>
			<form 
				:class="{'was-validated': errors.any()}"
				@submit.prevent="obtenerCredito" 
				class="credito" 
				novalidate
				ref="form"
			>
				<div class="row">
					<div class="title col-sm-12">Solicita tu <span>Crédito</span></div>
				</div>
				<div class="row">
					<div class="subtitle col-sm-12">Préstamo</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<input
							v-model="form.montoPrestamo"
							type="text"
							name="montoPrestamo"
							id="montoPrestamo"
							class="form-control"
							v-money="form.montoPrestamo !== null ? money : null"
							placeholder="Monto del préstamo"
							required
							data-vv-as="monto del préstamo"
							v-validate="'min_money:200000|max_money:5000000'"
						/>
						<div class="invalid-feedback">{{ errors.first('montoPrestamo') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<select v-model="form.plazos" name="plazos" id="plazos" class="form-control" required v-validate>
							<option :value="null" disabled selected>Plazos</option>
							<option value="1">1 años</option>
							<option value="2">2 años</option>
							<option value="3">3 años</option>
							<option value="4">4 años</option>
							<option value="5">5 años</option>
						</select>
						<div class="invalid-feedback">{{ errors.first('plazos') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="subtitle col-sm-12">Datos del solicitante</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<input
							v-model="form.nombre"
							type="text"
							name="nombre"
							id="nombre"
							class="form-control"
							placeholder="Nombres"
							required
							v-validate="'alpha_spaces'"
						/>
						<div class="invalid-feedback">{{ errors.first('nombre') }}</div>
					</div>
					<div class="col-sm-6">
						<input
							v-model="form.apellido_paterno"
							type="text"
							name="apellido_paterno"
							id="apellido_paterno"
							class="form-control"
							placeholder="Apellido paterno"
							data-vv-as="apellido paterno"
							required
							v-validate="'alpha_spaces'"
						/>
						<div class="invalid-feedback">{{ errors.first('apellido_paterno') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<input
							v-model="form.apellido_materno"
							type="text"
							name="apellido_materno"
							id="apellido_materno"
							class="form-control"
							placeholder="Apellido materno"
							data-vv-as="apellido materno"
							required
							v-validate="'alpha_spaces'"
						/>
						<div class="invalid-feedback">{{ errors.first('apellido_materno') }}</div>
					</div>
					<div class="col-sm-6">
						<input
							v-model="form.ingreso"
							type="text"
							name="ingreso"
							id="ingreso"
							class="form-control"
							placeholder="Ingreso mensual"
							v-money="form.ingreso !== null ? money : null"
							data-vv-as="ingreso mensual"
							required
							v-validate
						/>
						<div class="invalid-feedback">{{ errors.first('ingreso') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<input
							v-model="form.email"
							type="email"
							name="email"
							id="email"
							class="form-control"
							placeholder="Email"
							required
							v-validate
						/>
						<div class="invalid-feedback">{{ errors.first('email') }}</div>
					</div>
					<div class="col-sm-6">
						<input
							v-model="form.telefono"
							type="text"
							name="telefono"
							id="telefono"
							class="form-control"
							placeholder="Teléfono"
							data-vv-as="teléfono"
							required
							v-validate="'numeric|min:10|max:16'"
						/>
						<div class="invalid-feedback">{{ errors.first('telefono') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="subtitle col-sm-12">Datos de la garantía</div>
				</div>
				<div class="row">
					<div class="col-sm-6">
						<select v-model="form.tipoPropiedad" name="tipoPropiedad" id="tipoPropiedad" class="form-control" data-vv-as="tipo de propiedad" required v-validate>
							<option :value="null" disabled selected>Tipo de propiedad</option>
							<option value="1">Casa Sola</option>
							<option value="2">Casa Condominio</option>
							<option value="3">Departamento</option>
							<option value="4">Local Comercial</option>
							<option value="7">Oficina</option>
						</select>
						<div class="invalid-feedback">{{ errors.first('tipoPropiedad') }}</div>
					</div>
					<div class="col-sm-6">
						<input
							v-model="form.valorPropiedad"
							type="text"
							name="valorPropiedad"
							id="valorPropiedad"
							class="form-control"
							v-money="form.valorPropiedad !== null ? money : null"
							placeholder="Valor de propiedad"
							data-vv-as="valor de propiedad"
							required
							v-validate
						/>
						<div class="invalid-feedback">{{ errors.first('valorPropiedad') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<input
							v-model="form.cp"
							type="number"
							name="cp"
							id="cp"
							class="form-control"
							placeholder="Código postal"
							@keyup="searchCP"
							autocomplete="off"
							data-vv-as="código postal"
							required
							v-validate="'numeric|digits:5'"
						/>
						<div class="invalid-feedback">{{ errors.first('cp') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<input
							v-model="form.estado"
							type="text"
							name="estado"
							id="estado"
							class="form-control"
							placeholder="Estado"
							required
							v-validate
						/>
						<div class="invalid-feedback">{{ errors.first('estado') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<input
							v-model="form.municipio"
							type="text"
							name="municipio"
							id="municipio"
							class="form-control"
							placeholder="Municipio / Alcaldía"
							required
							v-validate
						/>
						<div class="invalid-feedback">{{ errors.first('municipio') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<select v-model="form.colonia" name="colonia" id="colonia" class="form-control" required v-validate>
							<option :value="null" disabled selected>Colonia</option>
							<option v-for="colonia in colonias" :value="colonia" :key="colonia">{{ colonia }}</option>
						</select>
						<div class="invalid-feedback">{{ errors.first('colonia') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<input
							v-model="form.calle"
							type="text"
							name="calle"
							id="calle"
							class="form-control"
							placeholder="Calle y número"
							required
							v-validate
						/>
						<div class="invalid-feedback">{{ errors.first('calle') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="subtitle col-sm-12">Como prefieres que te contactemos</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<select
							v-model="form.contacto_preferido"
							name="contacto_preferido"
							id="contacto_preferido"
							class="form-control"
							data-vv-as="forma de contacto"
							required
							v-validate
						>
							<option value="telefono">Teléfono</option>
							<option value="whatsapp">WhatsApp</option>
							<option value="email">Correo electrónico</option>
						</select>
					</div>
				</div>
				<div class="row form-check">
					<div class="col-sm-12 ">
						<input v-model="form.politicas" type="checkbox" name="politicas" id="politicas" class="form-check-input" required v-validate />
						<label class="form-check-label" for="politicas">
							Acepto las <a href="" title="">políticas de privacidad</a>
						</label>
						<div class="invalid-feedback">{{ errors.first('politicas') }}</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12 text-center">
						<button id="obtenerCredito" type="submit">Obtener mi crédito</button>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12 info">
						CAT Promedio informativo y para fines de comparación 33.3% para un crédito por un monto de $1,000,000 m.n.
						a 60 meses calculado a mayo 2019, el pago promedio mensual podría ser de $34,300.31 m.n. Este puede variar
						dependiendo del monto, plazo y perfil del cliente al momento de solicitar un crédito. Tasas desde 24% a
						28% anual. Plazos de pago de 1 a 5 años. Monto de $200 mil a $5 millones de pesos.
					</div>
				</div>
			</form>
			<div id="benefits" class="info-general container">
				<div class="row">
					<div class="col-sm-6">
						<p class="subtitle">Créditos desde <span>$200,000 MXN</span> hasta <span>$5,000,000 MXN</span></p>

						<ul>
							<li>Aún sin buen historial crediticio, te otorgamos un crédito</li>
							<li><strong>NO</strong> cobramos ningún tipo de comisión</li>
							<li>Tasa fija anual desde el 24% al 30%</li>
							<li>Paga tu crédito de 1 a 5 años</li>
							<li>Sin penalización por pago anticipado* <br /><small>*A partir del séptimo mes</small></li>
						</ul>
					</div>
				</div>
			</div>
			<div id="requisitos" class="requisitos container">
				<div class="row">
					<div class="col-sm-12 col-md-12 video">
						<div class="embed-responsive embed-responsive-16by9">
							<iframe
								class="embed-responsive-item"
								src="https://www.youtube.com/embed/S2YJOnJUZGk?controls=0&rel=0&modestbranding=1"
								frameborder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
							></iframe>
						</div>
					</div>
				</div>
			</div>
			<div id="ventajas" class="descript container">
				<div class="row">
					<div class="col-sm-12">
						<h2>
							Somos una Fintech mexicana que ofrece una alternativa a los créditos tradicionales. Desde el año 2014
							facilitamos el acceso a un préstamo con garantía fiduciaria.
						</h2>
					</div>
					<div class="col-sm-12 col-md-3">
						<span class="icon"><img src="https://bienparabien.com/img/2019/valores.svg" alt="Valores" /></span
						><span><h4>Valores</h4></span><br />
						<ul>
							<li>Fortaleza financiera.</li>
							<li>Integridad.</li>
							<li>Inclusión.</li>
							<li>Innonvación.</li>
						</ul>
					</div>
					<div class="col-sm-12 col-md-3">
						<span class="icon"><img src="https://bienparabien.com/img/2019/mision.svg" alt="Misión" /></span
						><span><h4>Misión</h4></span><br />
						Facilitar a millones de familias mexicanas que poseen una vivienda o bien inmueble un crédito accesible.
					</div>
					<div class="col-sm-12 col-md-3">
						<span class="icon"><img src="https://bienparabien.com/img/2019/vision.svg" alt="Visión" /></span
						><span><h4>Visión</h4></span><br />
						Ser la empresa fintech líder en Ameríca Latina en préstamos con garatía, reconocida por impulsar la
						inclusión financiera, por su innovación tecnológica, en productos y en efectividad de procesos.
					</div>
					<div class="col-sm-12 col-md-3">
						<span class="icon"><img src="https://bienparabien.com/img/2019/tech.svg" alt="Tecnología" /></span
						><span><h4>Innovación</h4></span><br />Utilizamos la tecnología a favor de nuestros clientes, agilizamos
						procesos utilizando uno de los más novedosos sistemas de Machine Learning para el proceso de entrevista.
					</div>
				</div>
			</div>
			<div id="plazas" class="plazas">
				<div class="bg">
					<div class="container">
						<div class="row">
							<div class="col-sm-12 subtitle">Estados en los que contamos con cobertura:</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<ul>
									<li>Aguascalientes</li>
									<li>Baja California</li>
									<li>Baja California Sur</li>
									<li>Campeche</li>
									<li>Chiapas</li>
									<li>Chihuahua</li>
									<li>Ciudad de México</li>
								</ul>
							</div>
							<div class="col-md-3">
								<ul>
									<li>Coahuila</li>
									<li>Colima</li>
									<li>Durango</li>
									<li>Estado de México</li>
									<li>Guanajuato</li>
									<li>Hidalgo</li>
									<li>Jalisco</li>
								</ul>
							</div>
							<div class="col-md-3">
								<ul>
									<li>Morelos</li>
									<li>Nayarit</li>
									<li>Nueva León</li>
									<li>Puebla</li>
									<li>Querétaro</li>
									<li>Quintana Roo</li>
									<li>San Luis Potosí</li>
								</ul>
							</div>
							<div class="col-md-3">
								<ul>
									<li>Sinaloa</li>
									<li>Sonora</li>
									<li>Tabasco</li>
									<li>Tlaxcala</li>
									<li>Veracruz</li>
									<li>Yucatán</li>
									<li>Zacatecas</li>
								</ul>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-12 button">
								<a href="https://bienparabien.com/faq" target="_blank" rel="noopener noreferrer"
									><button>Preguntas frecuentes</button></a
								>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="logos container">
				<div class="row">
					<div class="col-sm-2 col-md-2 offset-md-1">
						<a href="https://www.buro.gob.mx/" target="_blank" rel="noopener noreferrer">
							<img src="/images/logo_buro.png" alt="Ir al sitio de Buró de Crédito" />
						</a>
					</div>
					<div class="col-sm-2 col-md-2">
						<a href="http://www.condusef.gob.mx/" target="_blank" rel="noopener noreferrer">
							<img src="/images/condusef.png" alt="Ir al sitio de CONDUSEF" />
						</a>
					</div>
					<div class="col-sm-2 col-md-2">
						<a href="https://www.fintechmexico.org/" target="_blank" rel="noopener noreferrer">
							<img src="/images/Logo_fintech_mx.png" alt="Ir al sitio de Fintech Mexico" />
						</a>
					</div>
					<div class="col-sm-2 col-md-2">
						<a href="http://asofom.mx/asociados/" target="_blank" rel="noopener noreferrer">
							<img src="/images/asofom.png" alt="Ir al sitio de ASOFOM" />
						</a>
					</div>
					<div class="col-sm-2 col-md-2">
						<img src="/images/GCP.png" alt="Powered by Google Cloud Platform" />
					</div>
				</div>
			</div>
		</div>
		<div v-if="showVideo" class="player_bg" @click="showVideo = false"></div>
		<div v-if="showVideo" class="player_iframe">
			<iframe
				src="https://www.youtube.com/embed/62aXHIuGmSY?controls=0?autoplay=1&hd=1&rel=0?modestbranding=1"
				frameborder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
			></iframe>
		</div>
		<div v-if="showVideo" class="player_close" @click="showVideo = false">
			<img src="/images/close.png" alt="Cerrar" title="Cerrar" />
		</div>
		<div class="player_bg" v-if="form.montoPreAprobado !== null && form.montoPreAprobado != ''"></div>
		<div class="confirm-dialog container" v-if="form.montoPreAprobado !== null && form.montoPreAprobado != ''">
			<div class="row">
				<div class="col-sm-12 text-center">
					<img class="title" :src="mssg.img" alt="Success" />
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<div class="row">
						<div class="col-sm-12 subtitle">{{ mssg.subtitle }}</div>
					</div>
					<div class="row">
						<div class="col-sm-12 info">{{ mssg.mssg }}</div>
					</div>
					<div class="row">
						<div class="col-sm-12 text-center buttons">
							<button
								v-for="btn in mssg.buttons"
								:id="btn.id"
								:class="btn.class"
								:key="btn.id"
								@click="dynamicAction($event, btn.action)"
							>
								{{ btn.text }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<UploadFile :show.sync="uploadFiles" :solicitud="infoSolicitud"></UploadFile>
	</div>
	<div class="footer">
		Todos los derechos reservados. &copy; Bien para Bien SAPI de C.V, SOFOM ENR. {{ new Date().getFullYear() }}
	</div>
</div>
</template>

<script type="text/javascript">
import { Hooper, Slide } from 'hooper'
import 'hooper/dist/hooper.css'
import { VMoney } from 'v-money'
import firebase from 'firebase/app'
import 'firebase/firestore'
import Vue2Filters from 'vue2-filters'
import UploadFile from '@/modules/others/UploadFile'
import CodigoPostal from '@/api/servicios/codigo_postal'
import Solicitud from '@/api/originacion/solicitudes'

export default {
	components: {
		Hooper,
		Slide,
		VMoney,
		UploadFile,
	},
	directives: {
		money: VMoney,
	},
	data: () => {
		return {
			showVideo: false,
			money: {
				decimal: '.',
				thousands: ',',
				prefix: '$',
				precision: 0,
				masked: false,
			},
			colonias: [],
			form: {
				montoPrestamo: null,
				montoPreAprobado: null,
				aceptarPreAprobado: 0,
				plazos: null,
				nombre: null,
				apellido_paterno: null,
				apellido_materno: null,
				ingreso: null,
				email: null,
				telefono: null,
				tipoPropiedad: null,
				valorPropiedad: null,
				estado: null,
				municipio: null,
				colonia: null,
				calle: null,
				cp: null,
				contacto_preferido: 'telefono',
				politicas: false,
				createdAt: null,
				updatedAt: null,
			},
			mssg: {
				img: null,
				subtitle: null,
				mssg: null,
				buttons: [],
			},
			uploadFiles: false,
			infoSolicitud: null,
		}
	},
	computed: {
		plazosMeses: function () {
			return this.form.plazos * 12
		},
		montoPrestamoFloat: function () {
			let monto = this.form.montoPrestamo
			if (monto !== null) {
				monto = monto.replace(/\$/g, '')
				monto = monto.replace(/\,/g, '')

				return parseFloat(monto)
			} else return this.form.montoPrestamo
		},
	},
	methods: {
		cerrarSesion: function (e) {
			sessionStorage.setItem('auth', '')

			this.$router.push({ name: 'login' })
			firebase.auth().signOut()

			e.preventDefault()
		},
		validarEmail: function (e) {
			let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

			if (!reg.test(e.target.value)) {
				e.target.classList.add('is-invalid')
				this.$swal({
					type: 'error',
					title: 'Oops...',
					text: 'Debes especificar un email válido',
					toast: true,
					position: 'top-end',
					showConfirmButton: false,
					timer: 3500,
				})
			} else {
				if (e.target.classList.contains('is-invalid')) e.target.classList.remove('is-invalid')
			}
		},
		searchCP: function (e) {
			if (e.target.value.length >= 5) {
				CodigoPostal.find(e.target.value)
					.then((response) => {
						this.form.estado = response.estado
						this.form.municipio = response.municipio
						this.colonias = response.colonias
					})
					.catch((err) => {
						this.$swal({
							type: 'error',
							title: 'Oops...',
							text: err.message,
							toast: true,
							position: 'top-end',
							showConfirmButton: false,
							timer: 3500,
						})
					})
			}
		},
		importeCalc(tasa, ingreso_mensual, plazo) {
			const C3 = tasa
			const C8 = 1 / (1 + C3 / 12)
			const E3 = plazo

			const C9 = (1 - C8 ** E3) / (C3 / 12)
			const E24 = ingreso_mensual

			const C31 = C9
			const C32 = E24 * 0.35

			let resultado = C31 * C32

			if (resultado > 5000000) resultado = 5000000

			return resultado
		},
		obtenerCredito: async function () {
			if (this.$validator && await this.$validator.validateAll()) {
				this.form.ingreso = Number(this.form.ingreso.replace(/[^0-9.-]+/g,""))
				this.form.montoPreAprobado = this.importeCalc(0.28, this.form.ingreso, parseInt(this.plazosMeses)).toFixed(2)
				
				this.showAlert()
			}
		},
		aceptarPre: function (e) {
			this.form.aceptarPreAprobado = 1

			this.guardarDatos(e)
		},
		guardarDatos: function (e) {
			this.mssg.buttons.forEach(function (item) {
				document.getElementById(item.id).disabled = true
			})

			let monto_pre_a = document.getElementById('monto_pre_a')
			if (monto_pre_a) monto_pre_a.disabled = true

			let monto_org_a = document.getElementById('monto_org_a')
			if (monto_org_a) monto_org_a.disabled = true

			let monto_org_b = document.getElementById('monto_org_b')
			if (monto_org_b) monto_org_b.disabled = true

			let db = firebase.firestore()

			this.form.createdAt = new Date()
			this.form.updatedAt = new Date()

			db.collection('solicitudes')
				.add(this.form)
				.then((res) => {
					this.$log.info('Se guardan correctamente los datos')
				})
				.catch((err) => {
					this.$swal({
						type: 'error',
						title: 'Oops...',
						text: err.message,
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 3500,
					})
				})

			let importe_solicitado = this.form.montoPrestamo.replace(/\$/g, '')
			importe_solicitado = importe_solicitado.replace(/\,/g, '')

			let valorPropiedad = this.form.valorPropiedad.replace(/\$/g, '')
			valorPropiedad = valorPropiedad.replace(/\,/g, '')

			let ingreso_mensual = this.form.ingreso.replace(/\$/g, '')
			ingreso_mensual = ingreso_mensual.replace(/\,/g, '')

			Solicitud.create({
				email: this.form.email,
				password: this.form.email.split('@')[0].padEnd(5, '0'),
				nombre: this.form.nombre,
				paterno: this.form.apellido_paterno,
				materno: this.form.apellido_materno,
				ingreso_mensual: ingreso_mensual,
				telefono: this.form.telefono,
				//,celular: this.form.telefono
				monto_prestamo: importe_solicitado,
				plazo: this.form.plazos,
				medioinformacion_id: process.env.VUE_APP_MEDIO_INFORMACION,
				promotor_id: 2,
				descripcion_solicitud: 'Solicitud enviada vía micrositio Amex',
				acepta_politicas_privacidad: this.form.politicas,
				importe_pre_autorizado: this.form.montoPreAprobado,
				acepta_pre_autorizado: this.form.aceptarPreAprobado,
				metodo_preferido_contacto: this.form.contacto_preferido,
				tipogarantia_id: this.form.tipoPropiedad,
				propia: 1,
				calle: this.form.calle,
				colonia: this.form.colonia,
				cp: this.form.cp,
				delegacion: this.form.municipio,
				entidad: this.form.estado,
				valor: valorPropiedad,
			})
				.then((res) => {
					this.$log.info('res:', res)
					this.infoSolicitud = res
					this.$swal({
						type: 'success',
						title: 'Se ha registrado la solicitud correctamente',
						html:
							'En breve nos comunicaremos contigo vía telefónica y por correo electrónico<br/>Solicitud con ID: <strong>' +
							res.solicitud_id +
							'</strong>',
						showCancelButton: true,
						confirmButtonText: 'Subir documentos',
						cancelButtonText: 'Aceptar',
						reverseButtons: true,
						customClass: {
							confirmButton: 'btn btn-primary',
							cancelButton: 'btn btn-success',
						},
						buttonsStyling: false,
					}).then((res) => {
						if (res.value) {
							//Subir documentos
							this.uploadFiles = true
						}
					})

					this.mssg.buttons.forEach(function (item) {
						let btn = document.getElementById(item.id)

						if (btn) btn.disabled = false
					})

					this.form = {
						montoPrestamo: null,
						montoPreAprobado: null,
						aceptarPreAprobado: 0,
						plazos: 0,
						nombre: null,
						ingreso: null,
						email: null,
						telefono: null,
						tipoPropiedad: 0,
						valorPropiedad: null,
						estado: null,
						municipio: null,
						colonia: 0,
						calle: null,
						cp: null,
						contacto_preferido: 'telefono',
						politicas: false,
						createdAt: null,
						updatedAt: null,
					}

					this.colonias = []
				})
				.catch((err) => {
					let message = err.message

					if ('errores' in err.response.data) {
						message = err.response.data.errores.join(', ')
					}

					this.$swal({
						type: 'error',
						title: 'Oops...',
						text: message,
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 3500,
					})
				})
				.then(() => {
					if (monto_pre_a) monto_pre_a.disabled = false

					if (monto_org_a) monto_org_a.disabled = false

					if (monto_org_b) monto_org_b.disabled = false

					e.target.disabled = false

					this.mssg.buttons.forEach(function (item) {
						let btn = document.getElementById(item.id)

						if (btn) btn.disabled = false
					})
				})
		},
		noAceptar: function () {
			this.$log.info('No aceptar')
			this.form.montoPreAprobado = null
			this.mssg = {
				img: null,
				subtitle: null,
				mssg: null,
				buttons: [],
			}
		},
		dynamicAction: function (e, action) {
			this.$log.info('e', e)
			this.$log.info('action', action)

			switch (action) {
				case 'noAceptar':
					this.noAceptar()
					break
				case 'aceptarPre':
					this.aceptarPre(e)
					break
				case 'guardarDatos':
					this.guardarDatos(e)
					break
			}
		},
		showAlert: function () {
			let montoPrestamoRaw = this.form.montoPrestamo
			montoPrestamoRaw = montoPrestamoRaw.replace('$', '')
			montoPrestamoRaw = montoPrestamoRaw.split(',')
			montoPrestamoRaw = parseFloat(montoPrestamoRaw.join(''))

			let montoPreAprobadoRaw = parseFloat(this.form.montoPreAprobado) 

			// console.log('montos', montoPreAprobadoRaw, montoPrestamoRaw);
			// console.log('tipos', typeof(montoPreAprobadoRaw), typeof(montoPrestamoRaw));

			// console.log('pre menor',(montoPreAprobadoRaw < montoPrestamoRaw),(montoPreAprobadoRaw >= 200000));
			// console.log('pre mayor',(montoPreAprobadoRaw > montoPrestamoRaw),(montoPreAprobadoRaw <= 5000000));
			// console.log('mayor 5m',(montoPreAprobadoRaw >= 5000000));

			if (montoPreAprobadoRaw < montoPrestamoRaw && montoPreAprobadoRaw >= 200000) {
				this.mssg = {
					img: '/images/animat-checkmark-color.gif',
					subtitle: '¡Felicidades!',
					mssg:
						'Tu crédito ha sido aprobado por ' +
						this.$options.filters.currency(montoPreAprobadoRaw, '$', 0) +
						' con la mejor tasa del mercado.',
					buttons: [
						{
							text: 'Aceptar préstamo por ' + this.$options.filters.currency(montoPreAprobadoRaw, '$', 0),
							class: 'btn btn-success',
							action: 'aceptarPre',
							id: 'btnAceptarMontoPre',
						},
						{
							text: 'No me interesa',
							class: 'btn btn-danger',
							action: 'noAceptar',
							id: 'btnNoAceptar',
						},
					],
				}
			} else if (montoPreAprobadoRaw > montoPrestamoRaw && montoPreAprobadoRaw <= 5000000) {
				this.mssg = {
					img: '/images/animat-checkmark-color.gif',
					subtitle: '¡Felicidades, tienes un crédito preautorizado mayor al monto que esperabas!',
					mssg:
						'Puedes elegir ' +
						'entre ' +
						this.$options.filters.currency(montoPreAprobadoRaw, '$', 0) +
						' ó ' +
						this.form.montoPrestamo +
						'. Recuerda que la tasa de interés es la misma para ' +
						'las dos opciones.',
					buttons: [
						{
							text: 'Aceptar préstamo por ' + this.$options.filters.currency(montoPreAprobadoRaw, '$', 0),
							class: 'btn btn-success',
							action: 'aceptarPre',
							id: 'btnAceptarMontoPre',
						},
						{
							text: 'Aceptar préstamo por ' + this.form.montoPrestamo,
							class: 'btn btn-warning',
							action: 'guardarDatos',
							id: 'btnAceptarMonto',
						},
						{
							text: 'No me interesa',
							class: 'btn btn-danger',
							action: 'noAceptar',
							id: 'btnNoAceptar',
						},
					],
				}
			} else if (montoPreAprobadoRaw >= 5000000) {
				this.mssg = {
					img: '/images/animat-checkmark-color.gif',
					title: '¡Felicidades!',
					mssg: '¡Tienes un crédito preautorizado de $5,000,000 con la tasa más baja del mercado.',
					buttons: [
						{
							text: 'Aceptar préstamo por $5,000,000',
							class: 'btn btn-success',
							action: 'aceptarPre',
							id: 'btnAceptarMontoPre',
						},
						{
							text: 'Aceptar prestamo por ' + this.form.montoPrestamo,
							class: 'btn btn-success',
							action: 'guardarDatos',
							id: 'btnAceptarMonto',
						},
						{
							text: 'No me interesa',
							class: 'btn btn-danger',
							action: 'noAceptar',
							id: 'btnNoAceptar',
						},
					],
				}
			} else {
				this.mssg = {
					img: '/images/info.png',
					subtitle: null,
					mssg: 'Por favor revisa los datos que proporcionaste; ajusta el plazo o el monto. Si aún tienes problemas para crear la solicitud, comunícate con nosotros.',
					buttons: [
						{
							text: 'Aceptar',
							class: 'btn btn-primary',
							action: 'noAceptar',
							id: 'btnNoAceptar',
						},
					],
				}
			}
		},
	},
}
</script>

<style lang="less">
	.content {
		width: 100%;
		height: 100%;
		font-family: 'Montserrat', sans-serif;
		font-size: 14px;
		line-height: 1.5;
		overflow: auto;
		li, p{
			color: #444444;
		}
		input, select, label, button, .footer{
			font-family: 'Nunito Sans', sans-serif;
		}
		.white{
			color: #ffffff;
		}

		.header {
			nav {
				padding: 0.5rem;
				z-index: 1;
				box-shadow: 0 5px 10px -1px rgba(0,0,0,0.5);
				//background-color: #fff;
				height: auto;
				position: relative;

				a.navbar-brand {
					padding: 0;
					margin: 0;
					//position: absolute;
					//top: 30px;
					//left: 80px;

					img.logo_a {
						width: 70px;
					}

					img.logo_b {
						width: 120px;
						margin-left: 40px;
					}
				}

				#navMain {
					font-size: 1.3em;
					margin-left: 45vw;

					ul.navbar-nav {
						li.nav-item {
							a.nav-link {
								font-weight: bold;
								color: #444444;
								&:hover{
									color:#8fbc15;
								}
							}

							a.nav-active {
								color: #098dd8;//#00b169;
							}
						}
					}
				}
			}
		}

		.main {
			position: relative;

			.component {
				color: #444444;
				position: relative;
				overflow: auto;

				.hooper {
					height: 468px;
					// margin-bottom: 450px;
				}

				.credito-info {
					// background-color: rgba(255,255,255,0.4);
					width: 500px;
					font-size: 1.6em;
					color: #fff;
					padding: 20px;
					position: absolute;
					top: 0;
					left: 105px;

					.subtitle {
						line-height: 1.3;
						font-size: 1.5em;
						font-weight: bold;
						color:#098dd8 ;// rgb(202,224,80);
						// text-shadow: 5px 5px 5px #A3A3A3;
						margin-bottom: 20px;
					}
				}

				.credito {
					background-color: #fff;
					width: 35vw;
					padding: 20px;
					box-shadow: 0 0 10px grey;
					position: absolute;
					top: 16px;
					right: 130px;

					a {
						color: #8fbc15;//#00C874;
						text-decoration: underline;
					}

					.row {
						margin-bottom: 10px;

						.title {
							text-align: center;
							font-size: 1.8em;
							color:#098dd8 ;//rgb(201,224,79);

							span {
								color: #098dd8;//rgb(0,177,105);
								font-weight: bold;
							}
						}

						.subtitle {
							font-family: 'Nunito Sans', sans-serif;
							text-align: center;
							color: #098dd8;//#00C874;
							margin-top: 5px;
						}

						button {
							background-color: #098dd8;//#5177ad;
							width: 100%;
							font-size: 2em;
							color: #fff;
							padding: 20px 0px;
							border: solid 1px #098dd8//;#5177ad;
						}

						button:hover {
							background-color: #8fbc15;//#2873DF;
							border: 1px solid #8fbc15;
						}
					}
				}

				.info-general {
					margin-top: 70px;
					margin-bottom: 200px;

					.subtitle {
						font-size: 2.3em;
						margin-top: 20px;

						span {
							font-weight: bold;
							color: #098dd8;//rgb(0,177,105);
						}
					}

					ul {
						list-style: none;

						li {
							font-size: 1.3em;
							position: relative;
						}

						li:before {
							color: #8fbc15;//rgb(0,177,105);
							content: "\2022";
							position: absolute;
							top: 1px;
							left: -1.2em;
						}
					}
				}

				.requisitos {
					padding-top: 80px;
					.row {
						.video {
							//font-size: 2em;
							margin: 2rem 0;
							.embed-responsive{
								box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
							}

							span {
								color: #5177ad;
								font-weight: bold;
							}

							button {
								background-color: rgb(0,177,105);
								width: 250px;
								font-size: 0.7em;
								color: #fff;
								border: solid 1px rgb(0,177,105);
								margin-top: 30px;
								padding: 15px 0px;
							}
						}

						.pasos {
							ol {
								li {
									font-size: 1.7em;
									//font-size: 700;
									color: #444444;
									margin: 60px 0px;
									position: relative;

									span {
										font-size: initial;
									}

									img {
										position: absolute;	
										top: -17px;
										left: -95px;
									}
								}
							}
						}
					}
				}

				.descript {
					font-size: 1.2em;
					margin-bottom: 2rem;	
					.row {
						.col-sm-12 {
							h2{
								color: #098dd8;
								font-weight: 700;
								margin: 1rem 0;
							}
							span {
								text-align: center;
								font-size: 1.5em;
								color: #098dd8;//rgb(81,119,173);
								&.icon{
									img{
										display: block;
										margin: 10px auto;
										width: 100;
										max-width: 50px;
									}
								}
							}
						}

						.col-sm-12:first-child {
							span {
								margin-left: 25px
							}
						}
					}
				}

				.plazas {
					background-color: #378462;
					background-image: url('/images/deal.jpg');
					background-repeat: no-repeat;
					background-position: center;
					background-size: cover;
					font-size: 1.3em;
					color: #ffffff;
					box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

					.bg {
						background-color: rgba(0,177,105,.5);

						.container {
							.row {
								.subtitle {
									text-align: center;
									font-size: 2.4em;
									padding: 40px 0px;
									color: #ffffff;
								}

								.button {
									text-align: center;
									padding: 30px 0px;

									button {
										background-color: #ffffff;
										color: #098dd8;//#385b8d;
										font-weight: bold;
										padding: 15px 100px;
										border: solid 1px #ffffff;
										&:hover{
											background-color: #098dd8;
											color: #ffffff;
											border: 1px solid #098dd8;
										}
									}
								}
							}
						}
					}
					li{
						color: #ffffff;
					}
				}

				.logos {
					.row {
						.col-sm-2 {
							padding: 40px;
						}

						.col-sm-2:nth-child(1) {
							img {
								width: 75px;
							}
						}

						.col-sm-2:nth-child(2) {
							img {
								width: 75px;
							}
						}

						.col-sm-2:nth-child(3) {
							img {
								width: 75px;
							}
						}

						.col-sm-2:nth-child(4) {
							img {
								width: 114px;
							}
						}

						.col-sm-2:nth-child(5) {
							img {
								width: 187px;
							}
						}

						.disc {
							text-align: center;
							font-size: 1.2em;
							color: #000;
							padding-top: 10px;
						}
					}
				}
			}

			.player_bg {
				background-color: rgba(102,102,102,0.7);
				width: 100%;
				height: 100%;
				position: fixed;
				top: 0;
				left: 0;
			}

			.player_iframe {
				background-color: #fff;
				width: 640px;
				height: 360px;
				transform: translate(-50%, -50%);
				position: fixed;
				top: 50%;
				left: 50%;

				iframe {
					width: 100%;
					height: 100%;
				}
			}

			.player_close {
				// background-color: rgba(255, 255, 255, 0.5);
				width: 45px;
				height: 45px;
				font-size: 2em;
				font-weight: bold;
				text-align: center;
				color: #fff;
				padding: 0px 10px;
				position: fixed;
				top: 20px;
				right: 30px;
				z-index: 99999;

				img {
					width: 100%;
				}
			}

			.confirm-dialog {
				background-color: #fff;
				width: 60vw;
				padding: 20px;
				transform: translate(-50%, -50%);
				position: fixed;
				top: 50%;
				left: 50%;

				.title {
					width: 20%;
				}

				.subtitle {
					font-size: 1.7em;
					font-weight: bold;
					text-align: center;
					margin-bottom: 20px;
				}

				.info {
					text-align: center;
					margin-bottom: 20px;
				}

				.buttons {
					button {
						margin: 10px;
						border-radius: 0;
						min-width: 250px;
						width: auto;
						&.btn-success{
							background-color: #8fbc15;
							border-color: #8fbc15;
						}
						&.btn-warning{
							background-color: #f0ad4e;
							border-color: #f0ad4e;
						}
						&.btn-danger{
							background-color: #f1371b;
							border-color: #f1371b;
						}
					}
				}
			}
		}

		.footer {
			background-color: #098dd8;
			color: #ffffff;
			text-align: right;
			padding: 10px;
			// flex-shrink: 0;
		}
		.swal2-actions{
			.btn-primary{
				background-color: #098dd8;
				border-color: #098dd8;
				border-radius: 0;	
			}
			.btn-success{
				background-color: #8fbc15;
				border-color: #8fbc15;
				border-radius: 0;
			}
			.btn-warning{
				background-color: #f0ad4e;
				border-color: #f0ad4e;
				border-radius: 0;
			}
			.btn-danger{
				background-color: #f1371b;
				border-color: #f1371b;
				border-radius: 0;
			}
		}
	}
	@media screen and (max-width: 991px) {
		.content {
			.green-on-mobile{
				color: #8fbc15;
				text-align: center;
			}
			.blue-on-mobile{
				color: #098dd8;
				text-align: center;
			}
			input, select {
				margin: 5px 0;
			}
			.header{
				//margin-bottom: 1rem;
				position: fixed;
				background: #ffffff;
				top: 0;
				right: 0;
				width: 100%;
				z-index: 9;
			}
			.main {
				margin-top: 90px;
				.component {
					.credito-info {
						width: 450px!important;
						top: 60px!important;
						left: 30px!important;
					}

					.credito {
						right: 31px!important;
					}

					.requisitos {
						padding-top: 0;
						.row {
							.pasos {
								ol {
									li {
										margin-left: 30px;
										
										img {
											width: 50px !important;
											top: -3px !important;
											left: -82px !important;
										}
									}
								}
							}
							.video{
								margin: 2rem auto;
							}
						}
					}
					.descript{
						.row{
							div{
								text-align: center;
								br{
									display: none;
								}
							}
							&:first-of-type{
								span{
									margin-left: 0 !important;
									margin: 1rem 0;
									display: block;
								}
							}
						}
					}
					.plazas{
						box-shadow: 0;
						.button{
							button{
								padding: 15px 40px !important;
							}
						}
					}
					.logos{
						padding: 2rem 0.25rem;
						.row{
							.col-sm-2{
								width: 20%;
								padding: 1rem 0.5rem !important;
								text-align: center;
								img{
									max-width: 50px !important;
								}
							}
						}
					}

				}
			}
			.footer{
				text-align: center;
			}
		}
	}
	@media (max-width:767px){
		.content{
			.main {
				.component {
					.hooper {
						width: 100%!important;
						height: auto !important;

						.hooper-list {
							.hooper-track {
								.hooper-slide {
									img {
										width: 100%;
									}
								}
							}
						}
					}

					.credito-info  {
						width: 100%!important;
						color: #9E9E9E!important;
						padding-top: 3px !important;
						position: relative !important;
						top: auto !important;
						left: auto !important;

						.row {
							.subtitle {
								text-align: center;
								font-size: 1.3em;
							}
						}
					}

					.info-general {
						margin-bottom: auto !important;

						.row {
							.subtitle {
								text-align: center;
								font-size: 1.8em;
							}
						}
					}

					.credito{
						width: 90%;
						margin: auto;
						position: relative !important;
						top: auto !important;
						right: auto !important;
					}

					.requisitos {
						.row {
							.pasos {
								ol {
									li {
										margin-left: 30px;
										
										img {
											width: 50px !important;
											top: -3px !important;
											left: -82px !important;
										}
									}
								}
							}
						}
					}

					.logos {
						.row {
							.col-sm-12:last-child {
								img {
									margin-left: -47px;
								}
							}
						}
					}
				}
			}

			.player_iframe, .video {
				width: 96vw!important;
			}
		}
	}
	.swal2-actions{
		.btn{
			min-width: 150px;
			width: auto;
			margin: 0 10px;
			border-radius: 0;
		}
		.btn-primary{
			background-color: #098dd8;
			border-color: #098dd8;	
		}
		.btn-success{
			background-color: #8fbc15;
			border-color: #8fbc15;
		}
		.btn-warning{
			background-color: #f0ad4e;
			border-color: #f0ad4e;
		}
		.btn-danger{
			background-color: #f1371b;
			border-color: #f1371b;
		}
	}
</style>